module.exports = __webpack_public_path__ + "static/media/ccflogowhite.327206ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/ccflogowhite.svg
// module id = 669
// module chunks = 0